export default function formatInteger({ y: value = 0 }) {
  return Math.round(value)
}
